import type { AttendanceItem } from "views/Attendance/types"
import type { RequestLeaveItem } from "views/RequestLeave/types"

import { AlarmOff, Logout, PendingActions, SettingsRemote, WatchLater, WatchLaterOutlined } from "@mui/icons-material"
import { Box, Chip, Typography } from "@mui/material"
import { Flex, SurfacePaper } from "components/common"
import { DateTime } from "luxon"
import { getAttendanceOverview } from "views/Attendance/utils"

type Props = {
  attendances: AttendanceItem[]
  attendeeName?: null | string
  endDate: DateTime
  leaves: RequestLeaveItem[]
  startDate: DateTime
}

const AttendanceOverview = ({ attendances, attendeeName, endDate, leaves, startDate }: Props) => {
  const summary = getAttendanceOverview(attendances, leaves, startDate, endDate)

  return (
    <SurfacePaper sx={{ p: 1.5 }} variant="outlined">
      <Flex alignItems="center" className="flex-wrap" gap={1}>
        <Box minWidth={120}>
          <Typography fontWeight={700} variant="subtitle2">
            Tổng quan
          </Typography>
          <Typography color="text.secondary" variant="caption">
            {attendeeName || "Chấm công cá nhân"}
          </Typography>
        </Box>
        <Chip
          color="primary"
          icon={<WatchLaterOutlined />}
          label={`${(summary.totalMinutes / 60).toFixed(2)} giờ`}
          size="small"
          variant="outlined"
        />
        <Chip color="warning" icon={<WatchLater />} label={`Đi muộn: ${summary.lateCount}`} size="small" />
        <Chip
          color={summary.missingCheckoutCount > 0 ? "warning" : "default"}
          icon={<PendingActions />}
          label={`Chưa checkout: ${summary.missingCheckoutCount}`}
          size="small"
        />
        <Chip color="warning" icon={<AlarmOff />} label={`Về sớm: ${summary.requestEarlyCount}`} size="small" />
        <Chip color="error" icon={<Logout />} label={`Nghỉ: ${summary.leaveCount}`} size="small" />
        <Chip color="info" icon={<WatchLater />} label={`Xin muộn: ${summary.requestLateCount}`} size="small" />
        <Chip color="info" icon={<SettingsRemote />} label={`Remote: ${summary.remoteCount}`} size="small" />
      </Flex>
    </SurfacePaper>
  )
}

export default AttendanceOverview
